import * as THREE from 'three';

let Global = {
  gameTry: 0,
  delta: 0,
  isForward: true,
  envIntensity: 1.5,
  introPanTime: 1,
  utm_source: null,
  isGameActive: false,
  introShown: false,
  introActive: false,
  scaleFact: 1,
  pringlesSet: -1,
  carsTotal: 18,
  playerPos: new THREE.Vector3(),
  playerQuot: new THREE.Vector3(),
  introElapsed: { value: 0 },
  profileUrl: null,
  pringlesCollected: 0,
  soundEnabled: true,
  rotateFact: 1,
  roadMeshes: [],
  lang: 'ARB',
  gender: 'male',
  userName: '',
  email: null,
  mobile: null,
  name: '',
  email: '',
  countryCode: '',
  country: '',
  pringles: [],
  pringlesToCollide: [],
  junctions: {
    point_46: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_44: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_45: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_43: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_50: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_48: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_49: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_47: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_54: {
      x: 123.02921295166016,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_52: {
      x: 123.02921295166016,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_53: {
      x: 118.44745635986328,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_51: {
      x: 118.44745635986328,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_56: {
      x: 152.09327697753906,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_55: {
      x: 147.90428161621094,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_42: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_40: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_41: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_39: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_38: {
      x: -127.89582824707031,
      y: 0.06920445710420609,
      z: -0.8462002277374268,
    },
    point_37: {
      x: -127.89582824707031,
      y: 0.06920445710420609,
      z: -5.471802234649658,
    },
    point_22: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_20: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_21: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_19: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_26: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_24: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_25: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_23: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_18: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_16: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_17: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: -78.0378189086914,
    },
    point_15: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: -82.66342163085938,
    },
    point_65: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: 59.03534698486328,
    },
    point_64: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: 54.40974426269531,
    },
    point_84: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: 59.03534698486328,
    },
    point_63: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: 54.40974426269531,
    },
    point_67: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: 59.03534698486328,
    },
    point_66: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: 54.40974426269531,
    },
    point_62: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: 59.03534698486328,
    },
    point_61: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: 54.40974426269531,
    },
    point_77: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_75: {
      x: -0.7365887761116028,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_76: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_74: {
      x: -5.31834602355957,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_81: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_79: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_80: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_78: {
      x: 74.14439392089844,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_73: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_71: {
      x: -62.94941711425781,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_72: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_70: {
      x: -67.53117370605469,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_34: {
      x: 117.73546600341797,
      y: 0.06920445710420609,
      z: -38.85258102416992,
    },
    point_32: {
      x: 117.73546600341797,
      y: 0.06920445710420609,
      z: -43.47818374633789,
    },
    point_33: {
      x: 113.1537094116211,
      y: 0.06920445710420609,
      z: -38.85258102416992,
    },
    point_31: {
      x: 113.1537094116211,
      y: 0.06920445710420609,
      z: -43.47818374633789,
    },
    point_35: {
      x: 152.3636016845703,
      y: 0.06920445710420609,
      z: -43.47818374633789,
    },
    point_36: {
      x: 147.78184509277344,
      y: 0.06920445710420609,
      z: -38.85258102416992,
    },
    point_28: {
      x: 113.1537094116211,
      y: 0.06920445710420609,
      z: -78.2540283203125,
    },
    point_27: {
      x: 113.1537094116211,
      y: 0.06920445710420609,
      z: -82.879638671875,
    },
    point_7: {
      x: 117.73546600341797,
      y: 0.06920445710420609,
      z: -129.9427032470703,
    },
    point_8: {
      x: 113.1537094116211,
      y: 0.06920445710420609,
      z: -125.31709289550781,
    },
    point_4: {
      x: -0.6273040771484375,
      y: 0.06920445710420609,
      z: -125.31709289550781,
    },
    point_3: {
      x: -5.2090606689453125,
      y: 0.06920445710420609,
      z: -129.9427032470703,
    },
    point_6: {
      x: -5.2090606689453125,
      y: 0.06920445710420609,
      z: -116.83352661132812,
    },
    point_5: {
      x: -5.2090606689453125,
      y: 0.06920445710420609,
      z: -121.45913696289062,
    },
    point_2: {
      x: -96.45771026611328,
      y: 0.06920445710420609,
      z: -116.83352661132812,
    },
    point_1: {
      x: -101.03946685791016,
      y: 0.06920445710420609,
      z: -121.45913696289062,
    },
    point_14: {
      x: -96.45771026611328,
      y: 0.06920445710420609,
      z: -78.2841796875,
    },
    point_12: {
      x: -96.45771026611328,
      y: 0.06920445710420609,
      z: -82.9097900390625,
    },
    point_13: {
      x: -101.03946685791016,
      y: 0.06920445710420609,
      z: -78.2841796875,
    },
    point_11: {
      x: -101.03946685791016,
      y: 0.06920445710420609,
      z: -82.9097900390625,
    },
    point_10: {
      x: -128.22019958496094,
      y: 0.06920445710420609,
      z: -78.2841796875,
    },
    point_9: {
      x: -132.8019561767578,
      y: 0.06920445710420609,
      z: -82.9097900390625,
    },
    point_58: {
      x: -128.22019958496094,
      y: 0.06920445710420609,
      z: 46.967559814453125,
    },
    point_57: {
      x: -128.22019958496094,
      y: 0.06920445710420609,
      z: 42.341949462890625,
    },
    point_68: {
      x: -128.22019958496094,
      y: 0.06920445710420609,
      z: 110.12800598144531,
    },
    point_69: {
      x: -132.8019561767578,
      y: 0.06920445710420609,
      z: 114.75361633300781,
    },
    point_60: {
      x: -67.6041488647461,
      y: 0.06920445710420609,
      z: 46.967559814453125,
    },
    point_59: {
      x: -67.6041488647461,
      y: 0.06920445710420609,
      z: 42.341949462890625,
    },
    point_83: {
      x: 122.93498229980469,
      y: 0.06920445710420609,
      z: 114.68754577636719,
    },
    point_82: {
      x: 118.35322570800781,
      y: 0.06920445710420609,
      z: 110.06194305419922,
    },
    point_30: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -38.45960235595703,
    },
    point_29: {
      x: 78.72615051269531,
      y: 0.06920445710420609,
      z: -43.085205078125,
    },
  },
  collectablesConfig2: [],
  collectablesConfig: [
    {
      position: new THREE.Vector3(-132.5, 1, -60),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 5,
    },
    {
      position: new THREE.Vector3(-132.5, 1, -20),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2, 1, -40),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2, 1, 35),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5, 1, 45),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2, 1, 75),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2, 1, 100),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5, 1, 85),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5, 1, 10),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 65, 1, -60),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 5,
    },
    {
      position: new THREE.Vector3(-132.5 + 65, 1, -20),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 65, 1, -40),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 65, 1, 35),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 65, 1, 45),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 65, 1, 75),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 65, 1, 100),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 65, 1, 85),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 65, 1, 10),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 127.3, 1, -60),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 5,
    },

    {
      position: new THREE.Vector3(-128.2 + 127.3, 1, -40),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 127.3, 1, 35),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 127.3, 1, 45),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 127.3, 1, 75),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 127.3, 1, 100),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 127.3, 1, 85),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 127.3, 1, 10),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 206.5, 1, -60),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 5,
    },
    {
      position: new THREE.Vector3(-132.5 + 206.5, 1, -20),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 206.5, 1, -40),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 206.5, 1, 35),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 206.5, 1, 45),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 206.5, 1, 75),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 206.5, 1, 100),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 206.5, 1, 85),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 6,
    },
    {
      position: new THREE.Vector3(-132.5 + 206.5, 1, 10),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-132.5 + 245.3, 1, -60 - 50),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 5,
    },
    {
      position: new THREE.Vector3(-132.5 + 245.3, 1, -20 - 50),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 245.3, 1, -40 - 50),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 245.3, 1, -50),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 246.6, 1, 25),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 246.6, 1, 60),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 246.6, 1, 100),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 251, 1, 40),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 8,
    },
    {
      position: new THREE.Vector3(-128.2 + 251, 1, 90),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(0, 0, -3),
      count: 12,
    },
    {
      position: new THREE.Vector3(-120, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(-95, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 8,
    },
    {
      position: new THREE.Vector3(-110, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-93, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-80, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-58, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-45, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(-22, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-25, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(10, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 8, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 8, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 8, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 60, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 60, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 60, 1, 114.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 80, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(28 + 80, 1, 110.2),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-120, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(-95, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 8,
    },
    {
      position: new THREE.Vector3(-110, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-93, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-80, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-58, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-45, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(-22, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-25, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(10, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 8, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 8, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 8, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 60, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 60, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 60, 1, 114.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 80, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(28 + 80, 1, 110.2 - 115.5),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-120, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(-95, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 8,
    },
    {
      position: new THREE.Vector3(-110, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-93, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-80, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-58, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-45, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-39, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(-22, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-25, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(10, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 8, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 8, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 8, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 60, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(28 + 60, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(50 + 60, 1, 114.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10 + 80, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(28 + 80, 1, 110.2 - 193),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-52, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-35, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-20, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(10, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 6,
    },
    {
      position: new THREE.Vector3(35, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(55, 1, 110.2 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-45, 1, 106.1 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-27, 1, 106.1 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(7, 1, 106.1 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(27, 1, 106.1 - 52),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 7,
    },
    {
      position: new THREE.Vector3(-52 - 40, 1, 110.2 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-35 - 40, 1, 110.2 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-20 - 40, 1, 110.2 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-45 - 40, 1, 106.1 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-27 - 40, 1, 106.1 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(-40, 1, 106.1 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(20 - 40, 1, 106.1 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(0 - 40, 1, 110.2 - 227),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-52 - 40 + 120, 1, 110.2 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
    {
      position: new THREE.Vector3(-35 - 40 + 120, 1, 110.2 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-20 - 40 + 120, 1, 110.2 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(-45 - 40 + 120, 1, 106.1 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 2,
    },
    {
      position: new THREE.Vector3(-27 - 40 + 120, 1, 106.1 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 5,
    },
    {
      position: new THREE.Vector3(-40 + 120, 1, 106.1 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(20 - 40 + 120, 1, 106.1 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 3,
    },
    {
      position: new THREE.Vector3(0 - 40 + 120, 1, 110.2 - 236),
      rotation: new THREE.Vector3(-Math.PI / 8, 0, 0),
      direction: new THREE.Vector3(3, 0, 0),
      count: 4,
    },
  ],

  BASE_URL: 'https://www.newsfeedsmartapp.com/pringles/api/',
  URL_VUPDATE: 'https://www.newsfeedsmartapp.com/pringles/api/valueUpdator.php',

  assets: {
    cubemap: {
      // "0":
    },
    glbs: {
      pin: {
        key: 'pin',
        path: ['./models/pin.glb'],
        asset: null,
      },
      male: {
        key: 'male',
        path: ['./models/male.glb'],
        asset: null,
      },
      female: {
        key: 'female',
        path: ['./models/female.glb'],
        asset: null,
      },
      pringle: {
        key: 'pringle',
        path: ['./models/pringle.glb'],
        asset: null,
      },
      sky_wheel: {
        key: 'sky_wheel',
        path: ['./models/sky_wheel.glb'],
        asset: null,
      },

      city: {
        key: 'city',
        path: ['./models/city.glb'],
        asset: null,
      },
      road: {
        key: 'road',
        path: ['./models/road.glb'],
        asset: null,
      },
      car1: {
        key: 'car1',
        path: ['./models/car_1.glb'],
        asset: null,
      },
      car2: {
        key: 'car2',
        path: ['./models/car_2.glb'],
        asset: null,
      },
      car3: {
        key: 'car3',
        path: ['./models/car_3.glb'],
        asset: null,
      },
      car4: {
        key: 'car4',
        path: ['./models/car_4.glb'],
        asset: null,
      },
      car5: {
        key: 'car5',
        path: ['./models/car_5.glb'],
        asset: null,
      },
      car6: {
        key: 'car6',
        path: ['./models/car_6.glb'],
        asset: null,
      },
      car7: {
        key: 'car7',
        path: ['./models/car_7.glb'],
        asset: null,
      },
      car8: {
        key: 'car8',
        path: ['./models/car_8.glb'],
        asset: null,
      },
      car9: {
        key: 'car9',
        path: ['./models/car_9.glb'],
        asset: null,
      },
      car10: {
        key: 'car10',
        path: ['./models/car_10.glb'],
        asset: null,
      },
    },
    textures: {
      point: {
        key: 'point',
        path: ['./textures/point.png'],
        asset: null,
      },
      profile: {
        key: 'profile',
        path: ['./textures/default.png'],
        asset: null,
      },
      product_1: {
        key: 'product_1',
        path: ['./textures/product_1.jpg'],
        asset: null,
      },
      product_2: {
        key: 'product_2',
        path: ['./textures/product_2.jpg'],
        asset: null,
      },
      product_3: {
        key: 'product_3',
        path: ['./textures/product_3.jpg'],
        asset: null,
      },
      product_4: {
        key: 'product_4',
        path: ['./textures/product_4.jpg'],
        asset: null,
      },
      product_5: {
        key: 'product_5',
        path: ['./textures/product_5.jpg'],
        asset: null,
      },
      product_6: {
        key: 'product_6',
        path: ['./textures/product_6.jpg'],
        asset: null,
      },
      product_7: {
        key: 'product_7',
        path: ['./textures/product_7.jpg'],
        asset: null,
      },
      product_8: {
        key: 'product_8',
        path: ['./textures/product_8.jpg'],
        asset: null,
      },
      product_9: {
        key: 'product_9',
        path: ['./textures/product_9.jpg'],
        asset: null,
      },
      product_10: {
        key: 'product_10',
        path: ['./textures/product_10.jpg'],
        asset: null,
      },
    },
    sounds: {},
  },
};
export { Global };
